exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.diy-service-icon,\r\n.diy-service-icon img {\r\n  width: 40px;\r\n  height: 40px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/page/page/diy/params/Service.vue"],"names":[],"mappings":";AACA;;EAEE,YAAY;EACZ,aAAa;CACd","file":"Service.vue","sourcesContent":["\n.diy-service-icon,\r\n.diy-service-icon img {\r\n  width: 40px;\r\n  height: 40px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a76d558","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/page/page/diy/params/Service.vue
// module id = mF8m
// module chunks = 0